import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { ErrorResponse } from '../interfaces/error-response';

export class HttpErrorHandler {
    protected handleError(error: HttpErrorResponse) {
      const errorResp = <ErrorResponse>{};
      errorResp.responseCode = error.status;

      if (error.error instanceof ErrorEvent) {
        errorResp.message = 'Something went wrong, please try in a while.';
      } else {
          if (error.status === 400) {
              errorResp.message = error.error.Message;
          } else {
            errorResp.message = 'Something went wrong, please contact support.';
          }
      }
      return throwError(errorResp);
  }
}
